import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=0fda8838"
import script from "./ContactCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports